module.exports = __webpack_public_path__ + "static/media/Player.6142eca6.png";